'use client';
import { sendRequest, getImageUrl } from '@/lib/api-service';
import Image from 'next/image';
import Link from 'next/link';
import { useState, useEffect } from 'react';

export default function Page() {
	const [headerImage, setHeaderImage] = useState<string|null>(null);
	const [midImage, setMidImage] = useState<string|null>(null);
	useEffect(() => {
		const fetchDynamicImages = async () => {
			const response = await sendRequest('POST', '/dynamic-images/', {codes:["join_1", "join_2"]}, true);
			if (response && Array.isArray(response)) {
				const joinImg = response.find((img: { code: string }) => img.code === "join_1");
				if (joinImg && joinImg.image) setHeaderImage(joinImg.image);
				const joinImg2 = response.find((img: { code: string }) => img.code === "join_2");
				if (joinImg2 && joinImg2.image) setMidImage(joinImg2.image);
			}
		};
		fetchDynamicImages();
	}, []);
	

	return (
		<div className="bg-white mx-auto max-w-[1920px]">
			<div className="relative w-full h-[40vh]">
				{headerImage && (
					<Image
						src={getImageUrl(headerImage)}
						alt="Who we are"
						fill
						className="object-cover"
					/>
				)}
				<div className="absolute inset-0 bg-black/10 flex items-center justify-center">
					<h1 className="text-4xl md:text-6xl font-bold mb-4 drop-shadow-md header text-transparent bg-clip-text bg-gradient-to-b from-fire-500 to-fire-900 uppercase px-4 text-center">
						Бидэнтэй нэгдэх үү?
					</h1>
				</div>
				<div
					className="w-full h-[20vh] opacity-25 bg-no-repeat bg-top bg-cover absolute bottom-0"
					style={{ backgroundImage: "url('/waves/1.svg')" }}
				/>
				<div
					className="w-full h-[20vh] opacity-25 bg-no-repeat bg-top bg-cover absolute bottom-0"
					style={{ backgroundImage: "url('/waves/2.svg')" }}
				/>
				<div
					className="w-full h-[20vh] opacity-25  bg-no-repeat bg-top bg-cover absolute bottom-0"
					style={{ backgroundImage: "url('/waves/3.svg')" }}
				/>
				<div
					className="w-full h-[30vh]  bg-no-repeat bg-top bg-cover absolute bottom-0"
					style={{ backgroundImage: "url('/waves/low.svg')" }}
				/>
			</div>

			<div className="bg-white py-20 px-5">
				<div className="max-w-6xl mx-auto grid grid-cols-10 gap-x-8 gap-y-10 min-h-[600px]">
					<div className="col-span-4 flex flex-col justify-center space-y-6">
						<h2 className="text-3xl font-bold text-gray-900 leading-snug">
							Хамгийн гоё ажилд орох <span className="text-mountain-900">3 хялбар алхам</span>
						</h2>
						<ol className="list-decimal list-inside text-gray-700 space-y-1">
							<li>Ажлын байрны мэдээллийг уншаад хүсэлт илгээх</li>
							<li>Зуслангийн удирдлагатай ярилцлаганд оролцох</li>
							<li>Өөрийн хамгийн дуртай ажлыг эхлүүлэх</li>
						</ol>

						<h3 className="text-xl font-semibold text-gray-900 mt-6">Бид танд амлаж байна:</h3>
						<ul className="list-disc list-inside text-gray-700 space-y-1">
							<li>Мэргэжлийн түвшинд удирдах сургалт</li>
							<li>Хийсэн ажлын чин шударга цалин</li>
							<li>Бидний шилдэг багийн нэг гишүүн болох боломж</li>
							<li>Таны өсөлт хөгжилд тууштай дэмжлэг</li>
						</ul>
						<Link href="/about/contact" className='text-brand-500 underline font-semibold text-lg text-center'>Холбогдох</Link>
					</div>

					<div className="col-span-6 flex items-center justify-center">
						{midImage &&
						<img
							src={getImageUrl(midImage)}
							alt="Багийн зураг"
							className="rounded-2xl shadow-xl object-cover w-full h-full max-h-[400px]"
						/>}
					</div>
				</div>
			</div>
		</div>
	);
}
